<template>
    <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="70" height="50" fill="white"/>
        <path d="M13 45V5C13 3.89543 13.8954 3 15 3H55C56.1046 3 57 3.89543 57 5V45C57 46.1046 56.1046 47 55 47H15C13.8954 47 13 46.1046 13 45Z" stroke="currentColor"/>
        <rect x="17.5" y="7.5" width="4" height="4" stroke="currentColor"/>
        <rect x="25.5" y="7.5" width="4" height="4" stroke="currentColor"/>
        <rect x="33.5" y="7.5" width="4" height="4" stroke="currentColor"/>
        <rect x="17.5" y="15.5" width="4" height="4" stroke="currentColor"/>
        <rect x="25.5" y="15.5" width="4" height="4" stroke="currentColor"/>
        <rect x="17.5" y="23.5" width="4" height="4" stroke="currentColor"/>
        <rect x="48.5" y="38.5" width="4" height="4" stroke="currentColor"/>
        <rect x="48.5" y="30.5" width="4" height="4" stroke="currentColor"/>
        <rect x="40.5" y="38.5" width="4" height="4" stroke="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGShield',
};
</script>

<style scoped lang="scss">

</style>
